// Shared acceleration field logic for Deal and Installment forms.
// Acceleration lets repayments use a percentage of the selected Gross/Net
// revenue instead of the standard revenue margin/share.

export const resolveAccelerationOnLoad = ({
  accelerationPct,
  accelerationRevenueTotalType,
  revenueTotalType,
}) => {
  const accelerationEnabled = accelerationPct != null;
  return {
    accelerationEnabled,
    accelerationRevenueTotalType: accelerationEnabled
      ? accelerationRevenueTotalType || revenueTotalType || null
      : null,
  };
};

export const validateAcceleration = ({
  accelerationEnabled,
  accelerationPct,
  accelerationRevenueTotalType,
}) => {
  if (!accelerationEnabled) {
    return { isValid: true };
  }

  if (accelerationPct == null || accelerationPct === '' || Number(accelerationPct) <= 0) {
    return { isValid: false, message: 'Acceleration % must be greater than 0' };
  }

  if (!accelerationRevenueTotalType) {
    return { isValid: false, message: 'Acceleration Revenue Type is required when acceleration is enabled' };
  }

  return { isValid: true };
};
